import crypto from 'node:crypto';
import styled from '@emotion/styled';
import { Button, QRCode } from 'antd';
import type { FC } from 'react';
import { IconDownload } from '../../Icon';

interface Props {
  landingPage: string;
}

export const DownloadableQRCode: FC<Props> = ({ landingPage }) => {
  const qRCodeId = `QRCode_${crypto.createHash('sha256').update(landingPage).digest('hex')}`;

  const downloadQRCode = () => {
    const canvas = document.getElementById(qRCodeId)?.querySelector('canvas');
    if (canvas) {
      const url = canvas.toDataURL();
      const a = document.createElement('a');
      a.download = 'QRCode.png';
      a.href = url;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  return (
    <QRWithIcon id={qRCodeId}>
      <a href={landingPage} target="_blank" rel="noopener noreferrer">
        <QRCode size={140} bgColor="#fff" value={landingPage} />
      </a>
      <Button icon={<IconDownload />} type="primary" onClick={downloadQRCode}>
        Download
      </Button>
    </QRWithIcon>
  );
};

const QRWithIcon = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px; 
`;
